import React, {useEffect, useState} from 'react'
import { setActivePage, setActiveChildPage } from '../../../redux/actions/active-page'
import SearchContentField from '../../universal/search-content-field/search-content-field.component'
import DashboardPipelineUpperRow from './dashboard-pipeline-upper-row/'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import DashboardAddPipelineModal from './modals/add-unit-modal'
import DashboardEditPipelineModal from './modals/edit-unit-modal'
import DashboardNewPipelineModal from './modals/new-pipeline-modal'
import DashboardPipelineFlowContainer from './dashboard-pipeline-flow-container'
import DashboardEditExistingPipelineModal from './modals/edit-pipeline-modal'
import DashboardDeletePipelineUnitModal from './modals/delete-unit-modal'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import { resetAddSingleOpportunity, resetMovePipelineData, resetUpdatePipelineUnit, retrieveSinglePipelineDetails, retrieveUpdatedPipelineDetails, resetCreateNewPipeline, retrieveAllPipelines, resetDeleteSinglePipeline, resetUpdateSinglePipeline, resetDeletePipelineUnit } from '../../../redux/actions/pipeline'

import './style.scss';

const Index = () => {

	const dispatch = useDispatch()
	const [searchQuery, setSearchQuery] = useState("")

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const activePipeline = useSelector(state => state.pipeline.activePipeline?.id)
    const allPipelines = useSelector(state => state.pipeline.selections)

    const fetchAllPipelinesLoading = useSelector(state => state.pipeline.fetchAllPipelines.loading)

	const addUnitPipelineModal = useSelector(state => state.pipeline.showModals.addUnitPipelineModal)
	const editUnitPipelineModal = useSelector(state => state.pipeline.showModals.editUnitPipelineModal)
	const newPipelineModal = useSelector(state => state.pipeline.showModals.newPipelineModal)
	const editPipelineModal = useSelector(state => state.pipeline.showModals.editPipelineModal)
    const deletePipelineUnitModal = useSelector(state => state.pipeline.showModals.deletePipelineUnitModal)

    const addUnitStatus = useSelector(state => state.pipeline.addUnit.status)
    const addUnitLoading = useSelector(state => state.pipeline.addUnit.loading)
    const addUnitError = useSelector(state => state.pipeline.addUnit.error)

    const deleteUnitStatus = useSelector(state => state.pipeline.deleteUnit.status)
    const deleteUnitLoading = useSelector(state => state.pipeline.deleteUnit.loading)
    const deleteUnitError = useSelector(state => state.pipeline.deleteUnit.error)

    const updateUnitStatus = useSelector(state => state.pipeline.updateUnit.status)
    const updateUnitError = useSelector(state => state.pipeline.updateUnit.error)
    const updatedDataLoading = useSelector(state => state.pipeline.updatedData.loading)

    const moveDataStatus = useSelector(state => state.pipeline.moveUnit.status)
    const moveDataError = useSelector(state => state.pipeline.moveUnit.error)
    const moveDataLoading = useSelector(state => state.pipeline.moveUnit.loading)

    const deletePipelineStatus = useSelector(state => state.pipeline.deletePipeline.status)
    const deletePipelineError = useSelector(state => state.pipeline.deletePipeline.error)
    const deletePipelineLoading = useSelector(state => state.pipeline.deletePipeline.loading)

    const updatePipelineStatus = useSelector(state => state.pipeline.updatePipeline.status)
    const updatePipelineError = useSelector(state => state.pipeline.updatePipeline.error)
    const updatePipelineLoading = useSelector(state => state.pipeline.updatePipeline.loading)
    const updatePipelineId = useSelector(state => state.pipeline.updatePipeline.id)

    const addPipelineStatus = useSelector(state => state.pipeline.createPipeline.status)
    const addPipelineError = useSelector(state => state.pipeline.createPipeline.error)
    const addPipelineLoading = useSelector(state => state.pipeline.createPipeline.loading)

    const newPipelineId = useSelector(state => state.pipeline.createPipeline.id)

	const searchLibrary = e => {
    	setSearchQuery(e.target.value)
	}

	useEffect(() => {
		dispatch(setActivePage("pipeline"))
		dispatch(setActiveChildPage(null))
	})

	useEffect(() => {

    	if(addUnitStatus && addUnitStatus === "success"){
        	sendSuccessNotification("Mulighet ble oppdatert.")
        	dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: activePipeline}))
        	dispatch(resetAddSingleOpportunity())
    	}

    	if(addUnitError){
        	sendErrorNotification("Kunne ikke legge til i pipeline.")
            dispatch(resetAddSingleOpportunity())
    	}

	}, [addUnitStatus, addUnitError])

	useEffect(() => {

    	if(updateUnitStatus && updateUnitStatus === "success"){
        	sendSuccessNotification("Mulighet ble oppdatert.")
        	dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: activePipeline}))
        	dispatch(resetUpdatePipelineUnit())
    	}

    	if(updateUnitError){
        	sendErrorNotification("Kunne ikke oppdatere mulighet.")
        	dispatch(resetUpdatePipelineUnit())
    	}

	}, [updateUnitStatus, updateUnitError])

	useEffect(() => {

    	if(moveDataStatus && moveDataStatus === "success"){
        	sendSuccessNotification("Pipeline ble oppdatert.")
            dispatch(retrieveUpdatedPipelineDetails({companyId: selectedCompany, pipelineId: activePipeline}))
            dispatch(resetMovePipelineData())
        }

        if(moveDataError){
            sendErrorNotification("Kunne ikke oppdatere pipeline.")
            dispatch(resetMovePipelineData())
        }

    }, [moveDataStatus, moveDataError])

    useEffect(() => {

        if(deletePipelineStatus){
            sendSuccessNotification("Pipeline ble slettet.")
            dispatch(retrieveAllPipelines({companyId: selectedCompany}))
            if(allPipelines && allPipelines.length > 0 && !deletePipelineLoading){
                dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: allPipelines[0].id}))
            }
            dispatch(resetDeleteSinglePipeline())
        }

        if(deletePipelineError){
            sendErrorNotification("Kunne ikke slette pipeline.")
        }

    }, [deletePipelineStatus, deletePipelineError])

    useEffect(() => {

        if(updatePipelineStatus && updatePipelineStatus === "success"){
            sendSuccessNotification("Pipeline ble oppdatert.")
            dispatch(retrieveAllPipelines({companyId: selectedCompany}))
            if(!fetchAllPipelinesLoading && allPipelines.length > 0 && !updatePipelineLoading){
                dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: activePipeline}))
                dispatch(resetUpdateSinglePipeline())
            }
        }

        if(updatePipelineError){
            sendErrorNotification("Kunne ikke oppdatere pipeline.")
            dispatch(resetUpdateSinglePipeline())
        }

    }, [updatePipelineStatus, updatePipelineError, updatePipelineId, allPipelines])

    useEffect(() => {

        if(addPipelineStatus && addPipelineStatus === "success"){
            sendSuccessNotification("Ny pipeline ble opprettet.")
            dispatch(retrieveAllPipelines({companyId: selectedCompany}))
            if(!fetchAllPipelinesLoading && allPipelines.length > 0 && !addPipelineLoading){
                dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: newPipelineId}))
                dispatch(resetCreateNewPipeline())
            }
        }

        if(addPipelineError){
            sendErrorNotification("Kunne ikke opprette ny pipeline.")
            dispatch(resetCreateNewPipeline())
        }

    }, [addPipelineStatus, addPipelineError, addPipelineLoading, newPipelineId])

    useEffect(() => {

        if(deleteUnitStatus && deleteUnitStatus === "success"){
            sendSuccessNotification("Mulighet ble slettet.")
            dispatch(retrieveAllPipelines({companyId: selectedCompany}))
            if(!fetchAllPipelinesLoading && allPipelines.length > 0 && !updatePipelineLoading){
                dispatch(retrieveSinglePipelineDetails({companyId: selectedCompany, pipelineId: activePipeline}))
                dispatch(resetUpdateSinglePipeline())
                dispatch(resetDeletePipelineUnit())
            }
        }

        if(deleteUnitError){
            sendErrorNotification("Kunne ikke slette mulighet.")
            dispatch(resetDeletePipelineUnit())
        }
    }, [deleteUnitStatus, deleteUnitError])

    return(
		<section className="dashboard-pipeline-section">
			<div className="inner-dashboard-pipeline-container">
				<DashboardPipelineUpperRow/>
				{false && <SearchContentField searchQuery={searchQuery} handleSearch={searchLibrary}/>}
				<DashboardPipelineFlowContainer/>
				{addUnitPipelineModal ? <DashboardAddPipelineModal/>:null}
				{editUnitPipelineModal ? <DashboardEditPipelineModal/>:null}
				{newPipelineModal ? <DashboardNewPipelineModal/>:null}
				{editPipelineModal ? <DashboardEditExistingPipelineModal/>:null}
                {deletePipelineUnitModal ? <DashboardDeletePipelineUnitModal/>:null}
			</div>
			<ToastContainer/>
		</section>
    )
}

export default Index;